const SITE_URL = import.meta.env.VITE_SITE_URL ?? "https://example.com";

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${SITE_URL}/#organization`,
      "name": "Jon&Gコンサルティング株式会社",
      "url": SITE_URL,
      "logo": {
        "@type": "ImageObject",
        "url": "https://static.readdy.ai/image/d8b069ddd48bc477a2a24842dd85a982/329b63b1e93dd762fd884ab9d568547a.png"
      },
      "description": "人事組織・財務・営業コンサルティング、助成金活用診断、AI研修を提供するコンサルティングファーム",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "銀座一丁目22番11号 銀座大竹ビジデンス 2F",
        "addressLocality": "中央区",
        "addressRegion": "東京都",
        "postalCode": "104-0061",
        "addressCountry": "JP"
      },
      "areaServed": "JP",
      "founder": {
        "@type": "Person",
        "name": "岡 和明",
        "jobTitle": "代表取締役CEO"
      },
      "employee": [
        {
          "@type": "Person",
          "name": "岡 和明",
          "jobTitle": "代表取締役CEO"
        },
        {
          "@type": "Person",
          "name": "平岡 桃太",
          "jobTitle": "助成金事業責任者"
        }
      ]
    },
    {
      "@type": "ProfessionalService",
      "@id": `${SITE_URL}/#service`,
      "name": "Jon&Gコンサルティング株式会社",
      "url": SITE_URL,
      "image": `${SITE_URL}/og-image.jpg`,
      "description": "人事組織・財務・営業コンサルティング、助成金活用診断、AI研修を提供するコンサルティングファーム",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "銀座一丁目22番11号 銀座大竹ビジデンス 2F",
        "addressLocality": "中央区",
        "addressRegion": "東京都",
        "postalCode": "104-0061",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 35.6719,
        "longitude": 139.7658
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "18:00"
        }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "コンサルティングサービス",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "人事組織コンサルティング"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "財務コンサルティング"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "営業コンサルティング"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "助成金活用診断・提案"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "人材開発助成金対応 AI研修"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "セールス・キャリアコーチング"
            }
          }
        ]
      }
    },
    {
      "@type": "WebSite",
      "@id": `${SITE_URL}/#website`,
      "url": SITE_URL,
      "name": "Jon&Gコンサルティング株式会社",
      "inLanguage": "ja",
      "publisher": {
        "@id": `${SITE_URL}/#organization`
      }
    },
    {
      "@type": "WebPage",
      "@id": `${SITE_URL}/#webpage`,
      "url": SITE_URL,
      "name": "Jon&Gコンサルティング株式会社｜人事組織・財務・営業コンサルティング・助成金活用・AI研修",
      "description": "人と組織の可能性を最大化する。人事組織・財務・営業の3領域コンサルティング、助成金活用診断、AI研修で企業の成長を支援。",
      "inLanguage": "ja",
      "isPartOf": {
        "@id": `${SITE_URL}/#website`
      },
      "about": {
        "@id": `${SITE_URL}/#organization`
      },
      "dateModified": "2026-04-04"
    }
  ]
};

export default function SeoJsonLd() {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd, null, 2) }}
    />
  );
}
